<div ndtSnackBarLabel>{{data.message}}</div>

<div ndtSnackBarActions *ngIf="hasAction">
  <button type="button" ndt-tertiary-button ndtSnackBarAction (click)="action()">{{data.action}}</button>
</div>
